import React from "react";
import PropTypes from "prop-types";
import pe7IconMap from "./pe7IconMap";

const PE7_NAME_RE = /pe-7s-[a-z0-9-]+/;

export function extractPe7Name(value) {
  if (!value) {
    return null;
  }
  const match = String(value).match(PE7_NAME_RE);
  return match ? match[0] : null;
}

export default function PeIcon({ name, className, title, ...rest }) {
  const iconName = extractPe7Name(name) || extractPe7Name(className);
  const SvgIcon = iconName ? pe7IconMap[iconName] : null;

  const classes = ["pe-icon", className].filter(Boolean).join(" ");

  if (!SvgIcon) {
    return (
      <i className={classes} aria-hidden={!title} title={title} {...rest} />
    );
  }

  return (
    <i className={classes} aria-hidden={!title} title={title} {...rest}>
      <SvgIcon focusable="false" aria-hidden="true" />
    </i>
  );
}

PeIcon.propTypes = {
  name: PropTypes.string,
  className: PropTypes.string,
  title: PropTypes.string,
};
